import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Catalog from "./Catalog";
import Numbers from "./Numbers";
import Services from "./Services";
import HowToBuy from "./HowToBuy";
import Brands from "./Brands";
import Shipping from "./Shipping";
import WhyChoose from "./WhyChoose";
import Testimonials from "./Testimonials";
import QualityVideo from "./QualityVideo";
import ContactForm from "./ContactForm";
import Footer from "./Footer";
import CookieBanner, { WhatsAppFloat } from "./CookieBanner";
import { PreventivoProvider } from "./PreventivoContext";

const LandingPage = () => {
  return (
    <PreventivoProvider>
      <div className="bg-white text-left">
        <Header />
        <main>
          <Hero />
          <Catalog />
          <Numbers />
          <Services />
          <HowToBuy />
          <Brands />
          <Shipping />
          <WhyChoose />
          <Testimonials />
          <QualityVideo />
          <ContactForm />
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieBanner />
      </div>
    </PreventivoProvider>
  );
};

export default LandingPage;
